import styled from 'react-emotion';
import theme, { colors } from '@ublend-npm/aulaui-next-web/themes/default';

export const Container = styled.a`
  color: inherit;
  text-decoration: inherit;
`;

export const LogoContainer = styled.div`
  margin-right: ${theme.spacing.small};
  width: 24px;
  height: 24px;
`;

export const Title = styled.div`
  font-weight: ${theme.font.weight.semiBold};
  font-size: ${theme.font.size.copy};
`;

export const Header = styled.div`
  display: flex;
  flex-direction: row;
  align-items: center;
  margin-top: ${theme.spacing.xLarge};
`;

export const Description = styled.div`
  margin-top: ${theme.spacing.xSmall};
  font-size: ${theme.font.size.small};
  color: ${colors.grey11};
  line-height: 16px;
`;
